module.exports = __webpack_public_path__ + "img/icon_23years_tr.05c5554f.png";